import React, { FunctionComponent, ReactChild } from 'react';
import styles from './tabs-nav.module.scss';

export interface ITabsNavProps {
  children: ReactChild[];
  progressLinePostition: number;
  className?: string;
}

export const TabsNav: FunctionComponent<ITabsNavProps> = ({
  children,
  progressLinePostition,
  className
}) => (
  <div className={`${styles.tabsNav} ${className}`}>
    {children}
    <div
      style={{ left: progressLinePostition }}
      className={styles.progressLine}
    ></div>
  </div>
);
